import { injectable } from "inversify";
import { Message } from "Models/Message";
import { Dispatch } from "redux";
import { ActionTypes, IClearMessageToasterAction, IShowMessageToasterAction } from "./MessageToasterActionTypes";

export interface IMessageToasterAction {
    clearMessage(): any;
    showMessage(message: Message): any;
}

@injectable()
export class MessageToasterAction implements IMessageToasterAction {
    public clearMessage() {
        return (dispatch: Dispatch<IClearMessageToasterAction>) => {
            dispatch({
                type: ActionTypes.CLEAR_MESSAGE,
                data: undefined
            });
        };
    }

    public showMessage(message: Message) {
        return (dispatch: Dispatch<IShowMessageToasterAction>) => {
            dispatch({
                type: ActionTypes.SHOW_MESSAGE,
                data: message
            });
        };
    }
}


// WEBPACK FOOTER //
// ./src/Store/MessageToaster/MessageToasterAction.tsx